import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { Button, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import PercentIcon from "@mui/icons-material/Percent";

const Puller = styled("div")(({ theme }) => ({
  width: spacing.Spacing["4xl"].$value,
  height: spacing.Spacing.xs.$value,
  backgroundColor: colors.GrayLightMode[300].$value,
  borderRadius: spacing.Radius.xs.$value,
  position: "absolute",
  top: spacing.Spacing.xl.$value,
  left: "calc(50% - 15px)",
  ...theme.applyStyles("dark", {
    backgroundColor: colors.GrayLightMode[300].$value,
  }),
}));

export default function BrandsSortBy() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const [selected, setSelected] = React.useState<string[]>([]);

  const handleToggle = (value: string) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const options = [
    {
      label: "Registrations",
      value: "Registrations",
      icon: <ArrowUpwardIcon />,
    },
    { label: "Click out", value: "Click out" }, // no icon
    { label: "FTD", value: "FTD" },
    { label: "FTD", value: "FTD_", icon: <PercentIcon /> },
    { label: "QFTD", value: "QFTD" },
    { label: "QFTD", value: "QFTD_", icon: <PercentIcon /> },
    { label: "ROI", value: "ROI" },
    { label: "CPA Income", value: "CPA Income" },
    { label: "RS Income", value: "RS Income" },
    { label: "Total Income", value: "Total Income" },
    { label: "PV", value: "PV" },
    { label: "EPC", value: "EPC" },
    { label: "EPC CPA", value: "EPC CPA" },
    { label: "Brand ID", value: "Brand ID" },
  ];

  const ShortList = (
    <Box role="shortBy">
      <Puller />
      <Stack justifyContent={"end"} direction="row" p={1}>
        <IconButton
          aria-label="Logout"
          onClick={toggleDrawer(false)}
          sx={{
            width: spacing.Spacing["3xl"].$value,
            height: spacing.Spacing["3xl"].$value,
            color: colors.GrayLightMode[700].$value,
          }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>

      <Typography
        variant="body1"
        sx={{
          fontSize: typography.Size.Text.sm.$value,
          color: colors.GrayLightMode[700].$value,
        }}
      >
        Sort By
      </Typography>

      <Box sx={{ my: 2 }}>
        {options.map(({ label, value, icon }) => {
          const isSelected = selected.includes(value);

          return (
            <Button
              key={value}
              onClick={() => handleToggle(value)}
              startIcon={icon}
              variant={isSelected ? "outlined" : "outlined"}
              color="secondary"
              sx={{
                borderRadius: 2,
                mr: 1,
                mb: 1,
                py: spacing.Spacing.xs.$value,
                px: spacing.Spacing.lg.$value,
                textTransform: "capitalize",
                fontWeight:typography.Font_weight.Regular.$value,
                border: "1px solid" + colors.GrayLightMode[200].$value,
                color: colors.GrayLightMode[700].$value,
                fontSize: typography.Size.Text.sm.$value,

                ...(isSelected && {
                  border: "1px solid" + colors.Brand[600].$value + "!important",
                  boxShadow: "none !important",
                  color: colors.GrayLightMode[900].$value,
                }),
              }}
            >
              {label}
            </Button>
          );
        })}
      </Box>

      <Button
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          boxShadow: "none !important",
          background: colors.Brand[600].$value,
          borderRadius: 2,
        }}
      >
        Apply
      </Button>
    </Box>
  );

  return (
    <>
      <IconButton
        sx={{
          backgroundColor: colors.Brand[50].$value,
          borderRadius: spacing.Radius.full.$value,
          "&:hover": {
            backgroundColor: colors.Brand[100].$value,
          },
        }}
        color="secondary"
        size="small"
        onClick={toggleDrawer(true)}
      >
        <FilterListOutlinedIcon
          sx={{ color: colors.GrayLightMode[700].$value }}
        />
      </IconButton>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: spacing.Radius.xl.$value,
            borderTopRightRadius: spacing.Radius.xl.$value,
            p: spacing.Spacing.xl.$value + "!important",
          },
        }}
      >
        {ShortList}
      </Drawer>
    </>
  );
}
